import { useEffect, useState } from 'react';
import { SelectItem } from '$uikit/ListOfButtonSelect/ListOfButtonSelect.interface';
import { formatBigNumber } from '$utils';
import { PostsFilter } from '$store/profile/interface';
import { Total } from '$store/posts/interface';

export const useListOfButtonSelect = (total: Total) => {
  const [list, setList] = useState<SelectItem<ListValue>[]>([]);

  useEffect(() => {
    if (!total) {
      return;
    }

    const allCount = total['1'] + total['2'] + total['3'];

    if (allCount === 0) {
      return;
    }

    initialList.all.count = formatBigNumber(allCount);
    const newList = [initialList.all];

    if (total['1'] !== 0) {
      initialList.free.count = formatBigNumber(total['1']);
      newList.push(initialList.free);
    }

    if (total['2'] !== 0) {
      initialList.erotic.count = formatBigNumber(total['2']);
      newList.push(initialList.erotic);
    }

    if (total['3'] !== 0) {
      initialList.sponsors.count = formatBigNumber(total['3']);
      newList.push(initialList.sponsors);
    }

    setList(newList);
  }, [total]);

  return list;
};

type ListValue = keyof PostsFilter | 'all';

interface List<T> {
  all: SelectItem<T>;
  free: SelectItem<T>;
  erotic: SelectItem<T>;
  sponsors: SelectItem<T>;
}

const initialList: List<ListValue> = {
  all: {
    label: 'filters_all',
    value: 'all',
  },
  free: {
    label: 'filters_free',
    value: 'onlyFree',
  },
  erotic: {
    label: 'filters_erotic',
    value: 'onlyErotic',
  },
  sponsors: {
    label: 'filters_sponsors',
    value: 'onlySponsored',
  },
};
